module.exports = __webpack_public_path__ + "img/icon_image.f90df6ff.svg";